import DOMPurify from 'dompurify'

const LAZY_SVG_SPRITE_SELECTOR = '.lazy-svg-sprite'

function loadLazySprite (sprite) {
  fetch(sprite.dataset.url)
    .then(response => response.text())
    .then(text => DOMPurify.sanitize(text))
    .then(data => { sprite.innerHTML = data })
}

function loadLazySprites () {
  document.querySelectorAll(LAZY_SVG_SPRITE_SELECTOR).forEach((lazySprite) => {
    loadLazySprite(lazySprite)
  })
}

window.addEventListener('DOMContentLoaded', loadLazySprites)
